import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { take } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { RecentNavigationSnapshot, RequisitionVisitedSnapshot } from '@core/dashboard-types';
import { ResourceKind } from '@core/dashboard-types';
import type { Requisition } from '@core/requisitions-types';
import { RequisitionsSelectors } from '@recruitee/requisitions-data';

const mapToRecentNavigationSnapshot = (requisition: Requisition): RequisitionVisitedSnapshot => {
  const { id, title } = requisition;
  return { id, name: title, kind: ResourceKind.Requisition };
};

export const requisitionSnapshotResolver = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<RecentNavigationSnapshot> => {
  const store = inject(Store);

  return store
    .select(RequisitionsSelectors.byId(route.params.id))
    .pipe(filterBoolean, take(1), map(mapToRecentNavigationSnapshot));
};
